import { render, staticRenderFns } from "./NewSelectEng.vue?vue&type=template&id=8c20cfd6&scoped=true"
import script from "./NewSelectEng.vue?vue&type=script&lang=js"
export * from "./NewSelectEng.vue?vue&type=script&lang=js"
import style0 from "./NewSelectEng.vue?vue&type=style&index=0&id=8c20cfd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c20cfd6",
  null
  
)

export default component.exports